import React from 'react';
import { Navbar } from './Navbar';
import { useAuth } from '../contexts/AuthContext';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const {
    user
  } = useAuth();
  if (!user) {
    return <>{children}</>;
  }
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-112">
      <Navbar data-id="element-113" />
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-114">
        {children}
      </main>
      <footer className="bg-white border-t border-gray-200 py-4" data-id="element-115">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-gray-500" data-id="element-116">
          &copy; {new Date().getFullYear()} VIP CLEAN. Application interne v1.0
        </div>
      </footer>
    </div>;
}